import { render, staticRenderFns } from "./EditorDrawer.vue?vue&type=template&id=0bbb5554&"
import script from "./EditorDrawer.vue?vue&type=script&lang=js&"
export * from "./EditorDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports